import { GAME_IMAGE_ASSETS_ENDPOINT_V2 } from "../constants/game";

export const getGameImage = (
  type: "big" | "small",
  gameData?: { metadata?: string | null; id: string },
) => {
  let targetType: string = type;
  const caSmallType = `small_ca`;
  const gameImages = JSON.parse(gameData?.metadata || "null")?.gameImages;
  const imageUrl = GAME_IMAGE_ASSETS_ENDPOINT_V2 + gameData?.id;

  if (!gameImages?.[type]) {
    const firstKey = Object.keys(gameImages || {})[0];
    targetType = firstKey as "big" | "small";
  }
  if (type === "small" && gameImages?.[caSmallType]) {
    targetType = caSmallType;
  }

  if (gameImages?.[targetType]?.startsWith("http")) {
    return {
      png: gameImages?.[targetType],
      webp: gameImages?.[targetType],
      png2x: gameImages?.[`${targetType}2x`],
      webp2x: gameImages?.[`${targetType}2x`],
      png3x: gameImages?.[`${targetType}3x`],
      webp3x: gameImages?.[`${targetType}3x`],
    };
  }
  return {
    png: gameImages?.[targetType]
      ? imageUrl + `/${gameImages?.[targetType]}.png`
      : undefined,
    webp: gameImages?.[targetType]
      ? imageUrl + `/${gameImages?.[targetType]}.webp`
      : undefined,
    png2x: gameImages?.[`${targetType}2x`]
      ? imageUrl + `/${gameImages?.[`${targetType}2x`]}.png`
      : undefined,
    webp2x: gameImages?.[`${targetType}2x`]
      ? imageUrl + `/${gameImages?.[`${targetType}2x`]}.webp`
      : undefined,
    png3x: gameImages?.[`${targetType}3x`]
      ? imageUrl + `/${gameImages?.[`${targetType}3x`]}.png`
      : undefined,
    webp3x: gameImages?.[`${targetType}3x`]
      ? imageUrl + `/${gameImages?.[`${targetType}3x`]}.webp`
      : undefined,
  };
};

export const getCurrentGameVersion = (gameData?: string) => {
  if (!gameData) return null;
  try {
    const data = JSON.parse(gameData);
    return data?.currentGameVersion;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const getPathGameData = (gameData?: string, gameId?: string) => {
  // TODO: change cdn path
  const cdnPath = "https://assets.onmogaming.com/";

  const currentGameVersion = getCurrentGameVersion(gameData);
  const pathGameData = currentGameVersion
    ? `${cdnPath}games/${gameId}/${currentGameVersion}`
    : `${cdnPath}games/${gameId}/game.js`;
  return pathGameData;
};
